import Mob from './Mob'

/**
 * HunterMob class
 *      - a basic enemy that tries to eat your tail
 */
export default class extends Mob {
    constructor (location) {
        super(location)
        console.log('huntermob')
    }

    draw () {
        this.game.getScene().writeText(
            'Enemy',
            this.getX(),
            this.getY(),
            'rgba(255,0,255,.5)',
        )
        return this
    }
}
